import { DialogProps } from '@liquidweb-dev/undercurrent/Dialog';
import Typography from '@liquidweb-dev/undercurrent/Typography';
import Link from '@liquidweb-dev/undercurrent/Link';
import Button from '@liquidweb-dev/undercurrent/Button';
import HistoryIcon from '@liquidweb-dev/undercurrent/icons/lucide/History';
import DialogUTM from 'components/DialogUTM/DialogUTM';
// @ts-ignore
import BackupsMonitoringImg from 'images/utm/backups-monitoring-utm.png';

interface BackupsMonitoringProps extends Omit<DialogProps, 'onClose'> {
	onClose: () => void;
}

const BackupsMonitoring = ({
	onClose,
	...dialogProps
}: BackupsMonitoringProps) => {
	return (
		<DialogUTM
			{...dialogProps}
			image={BackupsMonitoringImg}
			badge={{
				icon: HistoryIcon,
				label: 'Backups & Monitoring',
			}}
			dialogContent={{
				title: 'Enable backups and images',
				description: (
					<Typography variant="body-md">
						Unexpected errors or deletions can lead to lost work. Visit your
						server&apos;s{' '}
						<Typography
							variant="body-md"
							sx={{
								fontWeight: 700,
							}}
						>
							Backups
						</Typography>{' '}
						tab to enable automated off-server protection that secures your
						files, databases, and applications.
					</Typography>
				),
			}}
			dialogAction={
				<Link
					href="https://docs.nexcess.com/hosting/server-administration/server-backup-and-restore/best-practices-developing-a-backup-plan/"
					target="_blank"
					rel="noopener"
					sx={{ width: 'fit-content' }}
				>
					<Button variant="secondary" size="medium">
						Learn more about Backups
					</Button>
				</Link>
			}
			onClose={onClose}
		/>
	);
};

export default BackupsMonitoring;
